import { render, staticRenderFns } from "./btLuckyTurntable.vue?vue&type=template&id=ad1cdd0c"
import script from "./btLuckyTurntable.vue?vue&type=script&lang=js"
export * from "./btLuckyTurntable.vue?vue&type=script&lang=js"
import style0 from "./btLuckyTurntable.vue?vue&type=style&index=0&id=ad1cdd0c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports